import React from 'react'

export default function Points(props) {

    return (
        <div className='points'>
            {props.nowPoints}
        </div>
    )
}


